import { createAsyncThunk } from '@reduxjs/toolkit';

import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

import { KhodroHttpGetService } from '../Services/KhodroHttpService';

export const getAllShakhsSalesShomarehBimehNamehHa = createAsyncThunk(
  'ShakhSalesBimehNamehPrint/GetAllShakhsSalesShomarehBimehNamehHa',
  async () => {
    return await KhodroHttpGetService({
      url: `${_apiPathManagerConfig?.Khodro.BimehNamehHayeShakhsSales.GetAllShakhsSalesShomarehBimehNamehHa}`,
    });
  }
);
